<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: "App",
  mounted() {
    this.$session.start();
    this.$axios.get("https://api.ipify.org/?format=json").then((res) => {
      this.$session.set("ipaddress", res.data.ip);
    });
  },
};
</script>